import { SelectOptions } from "@/types/snap-ui";

export const Languages: SelectOptions = [
  { name: "English", value: "en" },
  { name: "Arabic", value: "ar" },
  { name: "Chinese (Simplified)", value: "zh" },
  { name: "French", value: "fr" },
  { name: "German", value: "de" },
  { name: "Indonesian", value: "id" },
  { name: "Italian", value: "it" },
  { name: "Japanese", value: "ja" },
  { name: "Korean", value: "ko" },
  { name: "Nepali", value: "ne" },
  { name: "Polish", value: "pl" },
  { name: "Portuguese", value: "pt" },
  { name: "Romanian", value: "ro" },
  { name: "Russian", value: "ru" },
  { name: "Spanish", value: "es" },
  { name: "Swahili", value: "sw" },
  { name: "Ukrainian", value: "uk" },
  { name: "Vietnamese", value: "vi" },
];

export const languageName = (value: string): string =>
  Languages.find((language) => language.value === value)?.name || "Unknown";
